import type { ReactNode } from 'react';

/**
 * Progressive disclosure for explanatory copy: the page leads with one short line and the detail stays one click away
 * (and in the DOM, so screen readers and text search still reach it). Use for "how it works" prose, never for a
 * number, status or consequence the user needs before acting.
 */
export function More({ label = 'How this works', children, testId, open }: { label?: string; children: ReactNode; testId?: string; open?: boolean }) {
  return (
    <details className="more" data-testid={testId} open={open}>
      <summary>{label}</summary>
      <div className="more-body">{children}</div>
    </details>
  );
}
